module.exports = __webpack_public_path__ + "img/image-fiche-toiture-terrasse-modal.1602a036.png";